module.exports = __webpack_public_path__ + "img/奖章2级@3x.a1813432.png";